import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { ITransitionService } from '@src/slide/application/service/transition-service/transition-service-interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import {
    IEditorEditableServiceLayer,
} from '@src/slide/application/entry/toc/editor/base/service-layer/editable-service-layer.interface';
import {
    IEditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/base/service-layer/viewable-service-layer.interface';
import { IInfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';

export const getTransitionServiceConfig = (
    uiDataService: IUiDataService,
    viewableServiceLayer: IEditorViewableServiceLayer,
    editableServiceLayer: IEditorEditableServiceLayer,
    infrastructure: IInfrastructureBase,
):  IDynamicServiceConfig<ITransitionService> => ({
    name: 'transition-service',
    loadType: 'on-demand',
    async module() {
        const TransitionService = (await import('@src/slide/application/service/transition-service')).default;
        return new TransitionService(
            uiDataService,
            viewableServiceLayer.selectionService,
            viewableServiceLayer.mediaManager,
            editableServiceLayer,
            viewableServiceLayer,
            infrastructure,
        );
    },
});

